import React, { PropsWithChildren } from "react";
import { Modal } from "react-bootstrap";
import { CloseButton, Header, StyledModal } from "./styles";

interface CustomModalProps {
  children: any;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  maxWidth?: string;
  overflowVisible?: boolean;
  backdrop?: boolean | "static";
  centered?: boolean;
  scrollable?: boolean;
  size?: "sm" | "lg" | "xl";
}

export const CustomModal = ({
  children,
  isOpen,
  onClose,
  title,
  maxWidth,
  overflowVisible = false,
  backdrop = "static",
  centered = true,
  scrollable = true,
  size,
}: PropsWithChildren<CustomModalProps>): JSX.Element => {
  return (
    <StyledModal
      show={isOpen}
      onHide={onClose}
      maxWidth={maxWidth}
      backdrop={backdrop}
      centered={centered}
      scrollable={scrollable}
      overflowVisible={overflowVisible}
      size={size}>
      <Header>
        <span>{title}</span>
        <CloseButton aria-label="close" onClick={onClose} />
      </Header>
      <Modal.Body>{children}</Modal.Body>
    </StyledModal>
  );
};
